const ANALYTICS_BASE = 'https://analytics.elitepokerlounge.com';

export const fetchAnalyticsData = async ({ startDate, endDate }) => {
  const url = (!endDate || endDate === startDate)
    ? `${ANALYTICS_BASE}/fetch-data?startdate=${startDate}`
    : `${ANALYTICS_BASE}/fetch-data?startdate=${startDate}&enddate=${endDate}`;

  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Failed to fetch EPL/TCH data');
  }

  return response.json();
};
